import { FocusFeed } from "@/components/FocusFeed";

export default function Home() {
  return <FocusFeed />;
}
